import { useConfirmationDialogStore } from './confirmation-dialog-state';
import './confirmation-dialog.css';

export function ConfirmationDialog() {
  const {
    title,
    description,
    cancelText,
    confirmText,
    onCancel,
    onConfirm,
    onBackdropClick,
    visible,
  } = useConfirmationDialogStore();
  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget && onBackdropClick) {
      onBackdropClick();
    }
  };

  if (!visible) {
    return null;
  }

  return (
    <div
      className="cometchat-calls-confirmation-dialog-backdrop"
      onClick={handleBackdropClick}>
      <div className="cometchat-calls-confirmation-dialog">
        <div className="cometchat-calls-confirmation-dialog-content">
          <div className="cometchat-calls-confirmation-dialog-text">
            <h2 className="cometchat-calls-confirmation-dialog-title">
              {title}
            </h2>
            <p className="cometchat-calls-confirmation-dialog-description">
              {description}
            </p>
          </div>
          <div className="cometchat-calls-confirmation-dialog-buttons">
            <button
              className="cometchat-calls-confirmation-dialog-button cometchat-calls-confirmation-dialog-button-secondary"
              data-testid="cometchat-confirmation-dialog-cancel-button"
              onClick={onCancel}>
              {cancelText}
            </button>
            <button
              className="cometchat-calls-confirmation-dialog-button cometchat-calls-confirmation-dialog-button-primary"
              data-testid="cometchat-confirmation-dialog-confirm-button"
              onClick={onConfirm}>
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
